export const factTableConfig = {
     list: {
          tableMapper: [
               {
                    id: "name",
                    name: "Name",
                    isShow: true,
                    align: "left",
                    type: "text",
                    width: 200
               },
               // {
               //      id: "type",
               //      name: "Type",
               //      isShow: true,
               //      align: "center",
               //      type: "text",
               // },
               {
                    id: "labels",
                    name: "Labels",
                    isShow: true,
                    align: "center",
                    type: "label",
               },
               {
                    id: "totalRecords",
                    name: "Total Records",
                    isShow: true,
                    align: "center",
                    type: "text",
                    isNormalTest: true,
               },
               {
                    id: "inUse",
                    name: "In Use",
                    isShow: true,
                    align: "center",
                    type: "",
               },
               {
                    id: "active",
                    name: "Active",
                    isShow: true,
                    align: "center",
                    type: "activeButton",
               },
               {
                    id: "list1",
                    name: "",
                    isShow: true,
                    align: "center",
                    type: "",
               },
               {
                    id: "list2",
                    name: "",
                    isShow: true,
                    align: "center",
                    type: "",
               },
               {
                    id: "list3",
                    name: "",
                    isShow: true,
                    align: "center",
                    type: "",
               },
               // {
               //      id: "",
               //      name: "",
               //      isShow: true,
               //      align: "left",
               //      type: "",
               // },
          ],
     },

     schemaList: {
          tableMapper: [
               {
                    id: "name",
                    name: "Name",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "type",
                    name: "Type",
                    isShow: true,
                    align: "left",
                    type: "text",
               },
               {
                    id: "identity",
                    name: "Identity",
                    isShow: true,
                    align: "center",
                    type: "text",
               },
               {
                    id: "required",
                    name: "Required",
                    isShow: true,
                    align: "center",
                    type: "text",
               },

               {
                    id: "filterable",
                    name: "Filterable",
                    isShow: true,
                    align: "center",
                    type: "text",
               },
                
          ],
     },
};
